import {
  DE,
  ES,
  type FlagComponent,
  FR,
  GB,
  GR,
  HR,
  IT,
  JP,
  PL,
  SI,
} from "country-flag-icons/react/3x2";
import { MeReadDtoLangEnum } from "@/config/apiClient";

export const AVAILABLE_LANGS_OPTIONS: MeReadDtoLangEnum[] = [
  MeReadDtoLangEnum.De,
  MeReadDtoLangEnum.En,
  MeReadDtoLangEnum.Es,
  MeReadDtoLangEnum.Fr,
  MeReadDtoLangEnum.It,
  MeReadDtoLangEnum.Jp,
];

/**
 * Set of available languages for O(1) lookup without type casting
 */
export const AVAILABLE_LANGS_SET: Set<string> = new Set(
  AVAILABLE_LANGS_OPTIONS
);

/**
 * Display names for languages (in their own language)
 */
export const LANG_DISPLAY_NAMES: Record<MeReadDtoLangEnum, string> = {
  [MeReadDtoLangEnum.Fr]: "Français",
  [MeReadDtoLangEnum.En]: "English",
  [MeReadDtoLangEnum.De]: "Deutsch",
  [MeReadDtoLangEnum.It]: "Italiano",
  [MeReadDtoLangEnum.Es]: "Español",
  [MeReadDtoLangEnum.Jp]: "日本語",
  [MeReadDtoLangEnum.Gr]: "Ελληνικά",
  [MeReadDtoLangEnum.Pl]: "Polski",
  [MeReadDtoLangEnum.Hr]: "Hrvatski",
  [MeReadDtoLangEnum.Sl]: "Slovenščina",
};

/**
 * Explicit mapping of language codes to flag components
 * Avoids dynamic indexing and type assertions
 */
export const FLAG_COMPONENTS: Record<MeReadDtoLangEnum, FlagComponent> = {
  [MeReadDtoLangEnum.Fr]: FR,
  [MeReadDtoLangEnum.En]: GB,
  [MeReadDtoLangEnum.De]: DE,
  [MeReadDtoLangEnum.It]: IT,
  [MeReadDtoLangEnum.Es]: ES,
  [MeReadDtoLangEnum.Jp]: JP,
  [MeReadDtoLangEnum.Gr]: GR,
  [MeReadDtoLangEnum.Pl]: PL,
  [MeReadDtoLangEnum.Hr]: HR,
  [MeReadDtoLangEnum.Sl]: SI,
};

/**
 * Default language fallback
 */
export const DEFAULT_LANG = MeReadDtoLangEnum.En;
